var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#1B4458",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9171 26.4304H14.4842L11.9099 16.3206C11.7877 15.8556 11.5283 15.4444 11.1467 15.2507C10.1943 14.7637 9.14486 14.3762 8 14.1807V13.7915H13.5301C14.2934 13.7915 14.8658 14.3762 14.9612 15.0552L16.2969 22.3477L19.7281 13.7915H23.0656L17.9171 26.4304ZM24.9745 26.4304H21.7324L24.4021 13.7915H27.6442L24.9745 26.4304ZM31.8372 17.2929C31.9326 16.6121 32.505 16.2229 33.1729 16.2229C34.2223 16.1252 35.3655 16.3206 36.3196 16.8059L36.892 14.0847C35.9379 13.6955 34.8885 13.5 33.9361 13.5C30.7894 13.5 28.4997 15.2507 28.4997 17.6804C28.4997 19.5288 30.1216 20.4993 31.2665 21.084C32.505 21.667 32.9821 22.0563 32.8867 22.6393C32.8867 23.5137 31.9326 23.903 30.9802 23.903C29.8354 23.903 28.6905 23.6115 27.6427 23.1245L27.0703 25.8474C28.2152 26.3327 29.4538 26.5281 30.5986 26.5281C34.1269 26.6242 36.3196 24.8752 36.3196 22.25C36.3196 18.9441 31.8372 18.7504 31.8372 17.2929ZM47.6667 26.4304L45.0924 13.7915H42.3273C41.7549 13.7915 41.1825 14.1807 40.9917 14.7637L36.2248 26.4304H39.5623L40.2284 24.5837H44.3292L44.7108 26.4304H47.6667ZM42.8052 17.1953L43.7576 21.9587H41.0879L42.8052 17.1953Z",
    fill: "#1B4458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.906caaeb92b39ae2e24bcacaed3cc06d.svg";
export { ForwardRef as ReactComponent };